module.exports = __webpack_public_path__ + "img/nine2.b84b2120.png";